export { default } from './cta-block';
